export const environment = {
    production: false,
    // api: 'https://ams.kitamandiri.com',
    api: '/api',
    encryptionSecret: 'SECRET',
    accessTokenName: 'anti-fraud-access-token',
    client_id: '01JPETM6DBJ1TPSKZNKNSE5HB6',
};
